export default "__VITE_ASSET__CCXSPBJ8__"